import React from 'react';
import { GridColDef, GridColumnHeaderParams, GridRenderCellParams } from '@mui/x-data-grid-pro';
import GenericGridContent from '../../../../components/datagridComponents/GenericGridContent';
import ActionsMenu from '../../../../components/datagridComponents/ActionsMenu';
import { Category, CurrencyInfo } from '../../../../types';
import ButtonColourCell from '../../../../components/datagridComponents/ButtonColourCell';
import { currencyDisplay } from '../../../../helpers/helpers';

const BuildColumns = ({
  categoriesData,
  currencyInfo,
  locale,
}: {
  categoriesData: Category[];
  currencyInfo: CurrencyInfo;
  locale: string;
}): GridColDef[] => [
  {
    field: 'Name',
    flex: 0.5,
    minWidth: 100,
    editable: false,
    sortable: false,
    renderHeader: (_params: GridColumnHeaderParams) => (
      <GenericGridContent
        content={[
          {
            text: 'screens.products.products.name',
            shouldTranslate: true,
            typographyProps: {
              variant: 'boldText',
            },
          },
        ]}
      />
    ),
    renderCell: (params: GridRenderCellParams) => (
      <GenericGridContent
        content={[
          {
            text: params.value,
            shouldTranslate: false,
            typographyProps: {
              variant: 'body2',
            },
          },
        ]}
      />
    ),
  },
  {
    field: 'CategoryId',
    flex: 0.5,
    minWidth: 100,
    editable: false,
    sortable: false,
    renderHeader: (_params: GridColumnHeaderParams) => (
      <GenericGridContent
        content={[
          {
            text: 'screens.products.products.category',
            shouldTranslate: true,
            typographyProps: {
              variant: 'boldText',
            },
          },
        ]}
      />
    ),
    renderCell: (params: GridRenderCellParams) => {
      const categoryName = categoriesData?.find((category) => category?.Id === params?.value)?.Name;
      return (
        <GenericGridContent
          content={[
            {
              text: categoryName,
              shouldTranslate: false,
              typographyProps: {
                variant: 'body2',
              },
            },
          ]}
        />
      );
    },
  },
  {
    field: 'SalePriceIncTax',
    flex: 0.5,
    minWidth: 100,
    editable: false,
    sortable: false,
    renderHeader: (_params: GridColumnHeaderParams) => (
      <GenericGridContent
        content={[
          {
            text: 'screens.products.products.salePrice',
            shouldTranslate: true,
            typographyProps: {
              variant: 'boldText',
            },
          },
        ]}
      />
    ),
    renderCell: (params: GridRenderCellParams) => (
      <GenericGridContent
        content={[
          {
            text: currencyInfo.currencyISOCode
              ? currencyDisplay(params.value, locale, currencyInfo.currencyISOCode)
              : params.value,
            shouldTranslate: false,
            typographyProps: {
              variant: 'body2',
            },
          },
        ]}
      />
    ),
  },
  {
    field: 'CostPriceIncTax',
    flex: 0.5,
    minWidth: 100,
    editable: false,
    sortable: false,
    renderHeader: (_params: GridColumnHeaderParams) => (
      <GenericGridContent
        content={[
          {
            text: 'screens.products.products.costPrice',
            shouldTranslate: true,
            typographyProps: {
              variant: 'boldText',
            },
          },
        ]}
      />
    ),
    renderCell: (params: GridRenderCellParams) => (
      <GenericGridContent
        content={[
          {
            text: currencyInfo.currencyISOCode
              ? currencyDisplay(params.value, locale, currencyInfo.currencyISOCode)
              : params.value,
            shouldTranslate: false,
            typographyProps: {
              variant: 'body2',
            },
          },
        ]}
      />
    ),
  },
  {
    field: 'ButtonColourId',
    flex: 0.5,
    minWidth: 100,
    editable: false,
    sortable: false,
    renderHeader: (_params: GridColumnHeaderParams) => (
      <GenericGridContent
        content={[
          {
            text: 'screens.products.products.colour',
            shouldTranslate: true,
            typographyProps: {
              variant: 'boldText',
            },
          },
        ]}
      />
    ),
    renderCell: (params: GridRenderCellParams) => (
      <ButtonColourCell id={params.row.ButtonColourId} />
    ),
  },
  {
    field: 'actions',
    minWidth: 100,
    editable: false,
    sortable: false,
    renderHeader: (_params: GridColumnHeaderParams) => (
      <GenericGridContent
        content={[
          {
            text: 'common.actions',
            shouldTranslate: true,
            typographyProps: {
              variant: 'boldText',
            },
          },
        ]}
      />
    ),
    align: 'right',
    headerAlign: 'right',
    hideSortIcons: true,
    headerClassName: 'hideRightSeparator',
    cellClassName: 'actionsCell',
    renderCell: (params: GridRenderCellParams) => <ActionsMenu rowId={params.row.id.toString()} />,
    renderEditCell: (params: GridRenderCellParams) => (
      <ActionsMenu rowId={params.row.id.toString()} isInlineEdit />
    ),
  },
];

export default BuildColumns;
